const washingmachine = `Aihe: Pyykinpesukoneen kiireellinen korjauspyyntö
Arvoisa isännöitsijä
Kirjoitan ilmoittaakseni ongelmasta asuntoni pesukoneessa.
Koneesta vuotaa vettä eikä suorita pesujaksoa kunnolla, mikä aiheuttaa paljon ongelmia.
Olen huolissani siitä, että vesi voi vahingoittaa asuntoa, jos sitä ei korjata nopeasti.
On tärkeää korjata se mahdollisimman pian uusien ongelmien välttämiseksi.
Minulla on myös kasa pyykkiä, joka pitää pestä.
Lähetä joku korjaamaan pesukone mahdollisimman pian.
Arvostan nopeaa huomiotasi tähän asiaan.
Kiitos.
Ystävällisin terveisin,`;
export default washingmachine;